// extracted by mini-css-extract-plugin
module.exports = {"linkify":"linkify_linkify__Iq0_6"};